"use client";

import QuotationStudio from "../components/QuotationStudio";

export default function QuotationPage() {
  return <QuotationStudio />;
}
